import { apiClient } from './client';
import { PaginatedResponse } from '../types/pagination';
import { InquiryListItem, InquiryStatus } from '../types/inquiry';
import { LeadDetail } from '../types/lead';

export interface PublicInquiryPayload {
  firstName: string;
  lastName: string;
  email?: string;
  phone: string;
  countryOfInterest?: string;
  courseOfInterest?: string;
  message?: string;
  /** Honeypot: left blank by the real form, never shown to a human. */
  website?: string;
}

/** Unauthenticated — called from the public /inquire form. */
export const submitPublicInquiry = async (payload: PublicInquiryPayload): Promise<{ inquiryNumber: string }> => {
  const { data } = await apiClient.post('/inquiries/public', payload);
  return data.data;
};

export interface ListInquiriesParams {
  page: number;
  pageSize: number;
  status?: InquiryStatus;
  search?: string;
}

export const listInquiries = async (params: ListInquiriesParams): Promise<PaginatedResponse<InquiryListItem>> => {
  const { data } = await apiClient.get('/inquiries', { params });
  return data;
};

export const getInquiry = async (id: number): Promise<InquiryListItem> => {
  const { data } = await apiClient.get(`/inquiries/${id}`);
  return data.data;
};

export interface ConvertInquiryPayload {
  leadSourceId?: number;
  countryId?: number;
  interestedCourseId?: number;
  branchId?: number;
}

export const convertInquiry = async (id: number, payload: ConvertInquiryPayload): Promise<LeadDetail> => {
  const { data } = await apiClient.post(`/inquiries/${id}/convert`, payload);
  return data.data;
};

export const setInquiryStatus = async (id: number, status: 'SPAM' | 'DISCARDED'): Promise<InquiryListItem> => {
  const { data } = await apiClient.post(`/inquiries/${id}/status`, { status });
  return data.data;
};
